import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../api.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {Router, ActivatedRoute } from "@angular/router"
import { environment } from '../../../../environments/environment';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../../../_services/authentication.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    loginForm: FormGroup;
    FGPForm: FormGroup;
    loading = false;
    loading1 = false;
    submitted = false;
    returnUrl: string;
    error = '';
    message = '';
    class = '';

    constructor(
      private formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private authenticationService: AuthenticationService,
      private modalService: NgbModal,
      private http: HttpClient
  ) { 
      // redirect to home if already logged in
      if (this.authenticationService.currentUserValue) { 
          this.router.navigate(['/']);
      }
  }

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit() {
      this.loginForm = this.formBuilder.group({
          username: ['', Validators.required],
          password: ['', Validators.required],
      });
      
      this.FGPForm = this.formBuilder.group({
          email: ['', Validators.required]
      });

      // get return url from route parameters or default to '/'
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard/default';
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      if (this.loginForm.invalid) {
          return;
      }
console.log("jkhdfjhsdjkfb");


      this.loading = true;
      this.authenticationService.login(this.f.username.value, this.f.password.value)
          .pipe(first())
          .subscribe(
              data => {
                if(data.Error){
                  this.error = data.Error;
                  this.loading = false;
                  return 0;
                }else{
              
                  this.loading = false;
                  this.router.navigate(['/dashboard/default']);
                  console.log(data);
                  console.log(data.permission);
                }
                  
              },
              error => {
                  this.error = error;
                  this.loading = false;
              });
  }

  get f1() { return this.FGPForm.controls; }

  onSubmit1() {
      this.submitted = true;

      // stop here if form is invalid
      if (this.FGPForm.invalid) {
          return;
      }

      this.loading1 = true;
      this.http.post<any>(`${environment.apiUrl}/forgotpassword`, this.FGPForm.value).subscribe(
      res => {
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          this.loading1 = false;
          return 0;
        }else{
          this.message = 'Password Sent to Registered Email Id';
          this.class = 'btn btn-success';
        }
        window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  
}

